import {Injectable} from '@angular/core';
import {WindowPropertyInitializer} from "./window-property.initializer";
import {ReplaySubject} from "rxjs";

/**
 * This initializer waits until all the Knockout and related properties have been set on window before allowing the
 * Angular side to continue. This is to avoid race conditions as many parts of the Angular UI still depend on
 * The legacy code.
 */

@Injectable()
export class LegacyInitializer {

  legacyLoaded: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(private windowPropertyInitializer: WindowPropertyInitializer) { }

  wait(): Promise<any> {

    const propertiesRequired = [
      "LoggerFactory",
      "Debugger",
      "ErrorConsole",
      "TableManager",
      "I18n",
      "ClassUtil",
      "Navigate",
      "observable",
      "observableArray",
      "computed",
      "unwrapObservable",
      "isObservable",
      "isComputed",
      "isWritableObservable",
      "Util",
      "Table",
      "DateTime",
      "User",
      "dot",
      "StringUtils",
      "ScriptLibrary",
      "WebsocketAPI",
      "REST",
      "WS",
      "MessageBus",
      "Application",
      "RequestFactory",
      "Duration",
      "include",
      "KO",
      "KO_MAPPING",
      "KO_SAMMY_ROUTE_BRIDGE",
      "KO_REQUEST_FACTORY_BRIDGE.tableRecordAPI",
      "KO_REQUEST_FACTORY_BRIDGE.eventManager",
      "KO_REQUEST_FACTORY_BRIDGE.saveAs",
      "KO_REQUEST_FACTORY_BRIDGE.viewmodels",
      "KO_REQUEST_FACTORY_BRIDGE.i18n",
      "KO_REQUEST_FACTORY_BRIDGE.performanceMetrics",
      "KO_FIELD_DEFINITION_BRIDGE.createStandaloneFieldDefinition",
      "KO_FIELD_DEFINITION_BRIDGE.createStandaloneReferenceFieldDefinition",
      "KO_PAGE_CONTEXT",
      "KO_NAVIGATE_BRIDGE",
      "KO_INTERNATIONALIZATION_BRIDGE",
      "KO_MESSAGE_BUS_BRIDGE",
      // These are commented out for now because if you don't have a session they won't be set.
      // "KO_USER_BRIDGE.userTableRecord",
      // "KO_USER_BRIDGE.systemDefaults",
      // "KO_USER_BRIDGE.properties",
      // "KO_USER_BRIDGE.sofiUser",
      // "KO_USER_BRIDGE.userProfile",
      // "KO_USER_BRIDGE.homeURL",
    ];

    return this.windowPropertyInitializer.wait(propertiesRequired, "Legacy", this.legacyLoaded);
  }
}
